import { useCore } from '@/composables/core/index.js'
import { readonly, ref } from 'vue'

const isLoadingScreen = ref(false)

const show = (options = {}) => {
  const { store } = useCore()
  store.dispatch('loadingScreen/show', options)

  isLoadingScreen.value = true
}

const hide = () => {
  const { store } = useCore()
  store.dispatch('loadingScreen/hide')

  isLoadingScreen.value = false
}

export function useLoadingScreen () {
  return {
    show,
    hide,
    loadingScreenVisible: readonly(isLoadingScreen),
  }
}
